var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"patients"},[_c('ul',_vm._l((_vm.questionnaires),function(questionnaire){return _c('li',{key:questionnaire.questionnaire.name},[_c('router-link',{attrs:{"to":_vm.questionnaireUrl(questionnaire)}},[_c('p',[_vm._v(_vm._s(questionnaire.questionnaire.name))])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-511def5a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Patients/PatientQuestionnaires.vue
// module id = null
// module chunks = 